if (document.getElementById('page-business')) {
  const details = document.querySelectorAll('.businessDetails__list')

  const adjustDetail = () => {
    const point = document.documentElement.scrollTop + document.documentElement.clientHeight * 0.5

    const lists = document.querySelectorAll('.businessDetails__list:not(.open)')
    if (!lists.length) {
      window.removeEventListener('scroll', adjustDetail)
      return
    }

    lists.forEach((list) => {
      const rect = list.getBoundingClientRect()
      const top = rect.top + document.documentElement.scrollTop
      if (top < point) {
        list.classList.add('open')
      }
    })
  }

  window.addEventListener('scroll', adjustDetail)
  adjustDetail()
}
